import { render, staticRenderFns } from "./EmployeeAnnounceCMP.vue?vue&type=template&id=181fa3f7&scoped=true&"
import script from "./EmployeeAnnounceCMP.vue?vue&type=script&lang=js&"
export * from "./EmployeeAnnounceCMP.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeAnnounceCMP.vue?vue&type=style&index=0&id=181fa3f7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181fa3f7",
  null
  
)

export default component.exports